import { useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useNotificationPrefs } from "@/contexts/NotificationPrefs";
import { cn } from "@/lib/utils";

export function NotificationBell() {
  const { soundEnabled, setSoundEnabled, notificationPermission, requestNotificationPermission } =
    useNotificationPrefs();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid="button-notification-settings"
          aria-label={soundEnabled ? "Notification settings" : "Notifications muted — open settings"}
          title="Notification settings"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
        >
          {soundEnabled ? <Bell className="h-4 w-4" /> : <BellOff className="h-4 w-4" />}
        </button>
      </PopoverTrigger>
      <PopoverContent side="right" align="end" sideOffset={8} className="w-64 p-3">
        <div className="flex items-center justify-between gap-3">
          <span className="text-sm font-medium text-foreground">Sound on new message</span>
          <button
            type="button"
            onClick={() => setSoundEnabled(!soundEnabled)}
            aria-pressed={soundEnabled}
            aria-label={soundEnabled ? "Mute new message sound" : "Unmute new message sound"}
            className={cn(
              "inline-flex h-5 w-9 shrink-0 items-center rounded-full px-0.5 transition-colors",
              soundEnabled ? "bg-primary" : "bg-secondary",
            )}
          >
            <span
              className={cn(
                "h-4 w-4 rounded-full bg-white shadow-sm transition-transform",
                soundEnabled ? "translate-x-4" : "translate-x-0",
              )}
            />
          </button>
        </div>

        <div className="mt-3 flex items-center justify-between gap-3 border-t border-border pt-3">
          <span className="text-sm font-medium text-foreground">Desktop notifications</span>
          {notificationPermission === "granted" ? (
            <span className="text-xs text-muted-foreground">Enabled</span>
          ) : notificationPermission === "denied" ? (
            <span className="text-xs text-muted-foreground">Blocked in browser</span>
          ) : notificationPermission === "unsupported" ? (
            <span className="text-xs text-muted-foreground">Not supported</span>
          ) : (
            <button
              type="button"
              onClick={requestNotificationPermission}
              className="text-xs font-semibold text-primary hover:underline"
            >
              Enable
            </button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
